import dayjs, { Dayjs } from 'dayjs'
import locale from 'dayjs/locale/ru'

const updateLocale = require('dayjs/plugin/updateLocale')
const relativeTime = require('dayjs/plugin/relativeTime')
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
const weekOfYear = require('dayjs/plugin/weekOfYear')
const isoWeek = require('dayjs/plugin/isoWeek')

// Расширяем Day.js плагинами
dayjs.extend(isoWeek)
dayjs.extend(weekOfYear)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(weekOfYear)

dayjs.extend(updateLocale)
dayjs.extend(relativeTime)

dayjs.locale('ru', locale)

export { Dayjs }

export default dayjs
